export default __webpack_public_path__ + "static/media/TRANSPORT.753198bd.jpg";